import { render, staticRenderFns } from "./AnswerCard.vue?vue&type=template&id=404a9f18&scoped=true"
import script from "./AnswerCard.vue?vue&type=script&lang=js"
export * from "./AnswerCard.vue?vue&type=script&lang=js"
import style0 from "./AnswerCard.vue?vue&type=style&index=0&id=404a9f18&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404a9f18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('404a9f18')) {
      api.createRecord('404a9f18', component.options)
    } else {
      api.reload('404a9f18', component.options)
    }
    module.hot.accept("./AnswerCard.vue?vue&type=template&id=404a9f18&scoped=true", function () {
      api.rerender('404a9f18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/exam/components/AnswerCard.vue"
export default component.exports